module.exports = __webpack_public_path__ + "img/2010 winteressen 023.7ca3e5fb.jpg";